import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Translate from "react-translate-component";
import "../Navigation/Navigation.scss";
import Button from "../UI/Button/Button";
import { HashLink as Link } from "react-router-hash-link";
import navHome from "../../assets/images/homecare_icon.png";
import navResidental from "../../assets/images/clinic_icon.png";
import { FiChevronDown } from "react-icons/fi";

export const scrollWithOffset = (el, offset) => {
  const elementPosition = el.offsetTop - offset;
  window.scroll({
    top: elementPosition,
    left: 0,
    behavior: "smooth",
  });
};

const Navigation = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const menuRef = useRef(null);

  const toggleLogin = () => {
    setIsOpen(!isOpen);
  };

  const onLoginClick = () => {
    window.open(`${process.env.REACT_APP_AUTH_URI}`);
    setIsOpen(false);
  };

  const onHomecareClick = () => {
    window.open(`${process.env.REACT_APP_AUTH_HOMECARE_URI}`);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickEvent = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target))
        setIsOpen(false);
    };

    document.addEventListener("mousedown", handleClickEvent);
    document.addEventListener("touchstart", handleClickEvent);

    return () => {
      document.removeEventListener("mousedown", handleClickEvent);
      document.removeEventListener("touchstart", handleClickEvent);
    };
  }, [isOpen]);

  return (
    <nav>
      <div>
        <Link
          scroll={(el) => scrollWithOffset(el, 90)}
          to="/#aboutproduct"
          onClick={props.onClick}
        >
          <Translate content="header-nav.link1" />
        </Link>
        <NavLink
          to="/about"
          className="NavLink"
          activeClassName="active"
          onClick={props.onClick}
        >
          <Translate content="header-nav.link2" />
        </NavLink>
        {/* <Link
          scroll={(el) => scrollWithOffset(el, 90)}
          to="/#news"
          onClick={props.onClick}
        >
          <Translate content="header-nav.link3" />
        </Link> */}
        <NavLink
          to="/clanok"
          className="NavLink"
          activeClassName="active"
          onClick={props.onClick}
        >
          <Translate content="header-nav.link4" />
        </NavLink>

        <NavLink
          to="/contact"
          className="NavLink"
          activeClassName="active"
          onClick={props.onClick}
        >
          <Translate content="header-nav.link6" />
        </NavLink>
      </div>

      <div className="login-menu-wrapper" ref={menuRef}>
        <Button
          className={`${props.className} login-btn nav-btn`}
          onClick={toggleLogin}
        >
          <Translate content="header-nav.login" />
          <FiChevronDown className={`${isOpen ? "open-login" : ""}`} />
        </Button>
        {isOpen ? (
          <div className="login-drop">
            <div className="login-drop-btn" onClick={() => onHomecareClick()}>
              <img src={navHome} alt="" />
              <div className="btn-text">
                <Translate content="homepage.banner.login-homecare" />
                <p className="cs_text">
                  <Translate content="header-nav.login" />
                </p>
              </div>
            </div>
            <div className="login-drop-btn" onClick={() => onLoginClick()}>
              <img src={navResidental} alt="" />
              <div className="btn-text">
                <Translate content="homepage.banner.login-client" />
                <p className="cs_text">
                  <Translate content="header-nav.login" />
                </p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <NavLink
        to="/question-form"
        className="btn-questionnaire"
        // activeClassName="active"
      >
        <Button
          className={`orange-dark navigation ${props.btnQuestionnaire} nav-btn`}
          onClick={props.onClick}
        >
          <Translate content="header-nav.question-form" />
        </Button>
      </NavLink>
    </nav>
  );
};

export default Navigation;
